export const DEFAULT_CHUNK_SIZE = 25;
export const QUESTION_QUERY_LIMIT = 1000;
export const INITIAL_VALUE = 65535;
export const INCREMENT = 125;
export const POLL_INCREMENT = 355;
export const DEFAULT_MAX_INTERVAL = 25;
export const DEFAULT_MIN_INTERVAL = 15;
export const DEFAULT_STEP = 1;
export const UINT_32_ARRAY_MAX_VALUE = 0xFFFFFFFF;
